jQuery(function($){
	$('.example_gallery').magnificPopup({
		delegate: 'a',
		type: 'image',
		mainClass: 'mfp-img-mobile',
		removalDelay: 300,
		mainClass: 'mfp-fade',
		gallery: {
			enabled:true,//ギャラリー表示にする

		},
		image: {
			verticalFit: true // ブラウザ縦幅に合わせる
		},
	});

	$('a[href*=".jpg"], a[href*=".jpeg"], a[href*=".png"], a[href*=".gif"]').each(function(){
		if ($(this).parents('.wp-block-gallery').length == 0) {
			$(this).magnificPopup({
				type:'image',
				closeOnContentClick: true,
			});
		}
	});

	$('.wp-block-gallery').each(function() {
		$(this).magnificPopup({
			delegate: 'a',
			type: 'image',
			gallery: {
				enabled: true,
				navigateByImgClick: true,
				preload: [0, 1]
			}
		});
	});
});
